import { create } from 'zustand'

export type ToastTone = 'default' | 'success' | 'danger' | 'arcane'

export interface Toast {
  id: string
  title?: string
  message: string
  /** message may contain trusted HTML (e.g. a table result from the RPG API). */
  html?: boolean
  tone: ToastTone
  ttl: number
}

interface ToastState {
  toasts: Toast[]
  push: (t: Omit<Toast, 'id' | 'tone' | 'ttl'> & { tone?: ToastTone; ttl?: number }) => string
  dismiss: (id: string) => void
}

let seq = 0

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (t) => {
    const id = `toast-${++seq}-${Math.floor(Math.random() * 1e6)}`
    set((s) => ({ toasts: [...s.toasts, { id, tone: 'default', ttl: 6000, ...t }] }))
    return id
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
}))
